<template>
  <div class="menu-select-wrapper d-flex align-items-center">
    <v-select v-if="menuItems"
      :options="menuItems"
      v-model="selectedItem"
      placeholder="Sélectionnez un article"
      :get-option-label="option => option && option.name ? `${option.name} — ${option.priceAsFloat || ''}` : 'PAS DE DONNÉES'"
      :reduce="option => option.id"
      class="custom-vselect flex-grow-1"
      :appendToBody="!isMobile"
    >
    
    <template #search="{ attributes, events }">
        <input
          class="vs__search"
          :required="!selectedItem"
          v-bind="attributes"
          v-on="events"
        />
      </template>
    </v-select>

    <b-button
      variant="secondary"
      class="ml-2 " size="sm"
      :disabled="!selectedItem"
      @click="close"
    >
      <img src="@/assets/icons/close.svg" alt="valider" width="20" />
    </b-button>

     <b-button
      variant="primary"
      class="ml-2 " size="sm"
      :disabled="!selectedItem"
      @click="submitSelectedItem"
    >
      <img src="@/assets/icons/check-circle-white.svg" alt="valider" width="20" />
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    menuItems:{
      type:Array,
      default:() => null,
    },
    isMobile:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      selectedItem: null
    };
  },
  methods: {
    submitSelectedItem() {
      if (this.selectedItem) {
        this.$emit('item-selected', this.selectedItem);
      }
    },

    close() {
      this.$emit('item-close');
    }
  }
};
</script>

<style scoped>
.menu-select-wrapper {
  max-width: 450px;
  margin: 0 auto;
}


</style>
